"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Host = 'frog.wix.com';
exports.LoggerVersion = '2.0.270';
var PublishMethods;
(function (PublishMethods) {
    PublishMethods["Auto"] = "auto";
    PublishMethods["PostMessage"] = "postMessage";
})(PublishMethods = exports.PublishMethods || (exports.PublishMethods = {}));
var Errors;
(function (Errors) {
    Errors[Errors["Unsupported"] = 0] = "Unsupported";
})(Errors = exports.Errors || (exports.Errors = {}));
var EventContextMap;
(function (EventContextMap) {
    EventContextMap["msid"] = "_msid";
    EventContextMap["clientId"] = "_client_id";
    EventContextMap["uuid"] = "_uuid";
    EventContextMap["visitorId"] = "_visitorId";
    EventContextMap["siteMemberId"] = "_siteMemberId";
})(EventContextMap = exports.EventContextMap || (exports.EventContextMap = {}));
//# sourceMappingURL=constants.js.map